import React, { useContext, useEffect } from 'react'

export const DialogsContext = React.createContext()

export const useDialogs = () => useContext(DialogsContext)

export const useDialogsBlocker = (fn, deps = []) => {
  const { block, unblock } = useContext(DialogsContext)

  useEffect(() => {
    block(fn)
    return unblock
  }, deps)
}

export const withDialogs = Comp => props => (
  <DialogsContext.Consumer>
    {providerProps => <Comp {...props} dialogs={providerProps} />}
  </DialogsContext.Consumer>
)
